import { ReportFeatures } from '@hcs/types';

export const COMPS_LIST_MAP_FEATURES = [ReportFeatures.CompsSelect];
